import {noop} from '@logistics-frontend/utils'
import {useCallback} from 'react'
import {useFormContext} from 'react-hook-form'

export const useOrderAction = (): {triggerAction: VoidFunction} => {
  const {handleSubmit} = useFormContext()

  const triggerAction = useCallback(() => {
    // TODO: Подцепиться к tanstack-запросу
    void handleSubmit(noop)()
  }, [handleSubmit])

  return {triggerAction}
}
